import { styled } from 'styled-components';

import { Media } from '../../../../../theme/Media.tsx';
import Label from '../../../../Form/Label/index.tsx';

interface NoteWrapperProps {
  $compact: boolean;
}

export const NoteWrapper = styled.div<NoteWrapperProps>`
  padding: ${({ $compact }) => ($compact ? '8px 12px' : '16px 24px')};
  background-color: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  gap: 8px;
  align-items: flex-start;

  @media ${Media.xsMax} {
    padding: 8px 12px;
  }
`;

export const StyledLabel = styled(Label)`
  white-space: nowrap;
`;
